export default "__VITE_ASSET__3a9dce4b__"